import { useState, useMemo, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import { Autoplay } from 'swiper/modules';
import { preFixImgUrl } from '@/utils'
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperType } from 'swiper';
import classNames from 'classnames'
import OutLink from '@/components/OutLink';
import { useNavigate } from 'react-router-dom';
import { PlatformEnum } from '@/service/api/types';

const SagawaExp = () => {
  const { t } = useTranslation();
  const swiperRef = useRef<SwiperType | null>(null)
  const [activeSwiper, setActiveSwiper] = useState(0)
  const navigate = useNavigate();
  const services = useMemo(() => [
    {
      titleKey: '498f0c35',
      img: preFixImgUrl('ecdaaa13f9ac907328a7af19802fa94f.png'),
    },
    {
      titleKey: '5f0b58af',
      img: preFixImgUrl('7ee3f50888d5230f572cd9caefc1b4fe.png'),
    },
    {
      titleKey: '69fd2eb1',
      img: preFixImgUrl('7fd2b3b2c5ea33e771f880cf0667134f.png'),
    },
    {
      titleKey: '9eac6ba3',
      img: preFixImgUrl('f3f8bf25a82e052412ce55c4f18f5f07.png'),
    },
  ], [t])

  return (
    <div className=''>
      <div className='h-[800px] bg-cover bg-center bg-no-repeat flex items-center justify-center' style={{ backgroundImage: `url(${preFixImgUrl('ab0fcf0a772beace08ab0d7009dcd960.png')})` }}>
        <div className='w-8xl mx-auto px-10'>
          <div className='bg-[#EEF7FF] rounded-[20px] px-[60px] py-[68px] flex items-center justify-between'>
            <div className='flex flex-col gap-6'>
              <div className='rounded-[12px] rounded-bl-[0] bg-[#3096FF] w-fit h-[35px] leading-[35px]'>
                <LangText lngKey='c45d7182' className='text-white text-[18px] px-3'>{t('c45d7182')}</LangText>
              </div>
              <LangText lngKey='b057a73b' className='text-[44px] font-bold text-black'>{t('b057a73b')}</LangText>
              <LangText lngKey='c6831487' className='text-[18px] text-[#666666] w-[450px] leading-[1.5]'>{t('c6831487')}</LangText>
              <div className='flex gap-4'>
                <OutLink platform={PlatformEnum.SGW}>
                  <div className='h-[47px] px-[35px] flex items-center justify-center rounded-[24px] w-fit text-[18px] bg-linear-to-r from-[#3984FF] to-[#0DACFF] text-white cursor-pointer'>
                    <LangText lngKey='ad8b9d1b'>{t('ad8b9d1b')}</LangText>
                  </div>
                </OutLink>
                {/* <div className='h-[47px] px-[35px] flex items-center justify-center rounded-[24px] outline outline-[#131313] w-fit text-[18px] hover:bg-linear-to-r from-[#3984FF] to-[#0DACFF] hover:text-white hover:outline-none cursor-pointer'>
                <LangText lngKey='d54d00ca'>{t('d54d00ca')}</LangText>
              </div> */}
              </div>
            </div>
            <div className='w-[484px] h-[353px] bg-linear-to-t from-[#D2E9FD] to-[#DEEFFF] rounded-[34px] flex flex-col justify-center justify-end'>
              <img src={preFixImgUrl('131b5c1cb11690695b7cdfb7e7637513.png')} className='h-[340px]' />
            </div>
          </div>
        </div>
      </div>
      {/* 配送服务 */}

      <div className='bg-[#EDF5F9] pt-[170px] pb-[160px]'>
        <div className='max-w-8xl mx-auto px-10 flex flex-col items-center'>
          <LangText className='text-[36px] font-bold' lngKey='f200b200'>{t('f200b200')}</LangText>
          <div className='flex gap-5 mt-[90px] w-full'>
            <div className='flex-1 bg-white min-h-[406px] rounded-[30px] p-10 lang-en:p-9 flex flex-col'>
              <img src={preFixImgUrl('943abc22579b98a74c787dafd58cd227.png')} className='w-[64px] h-[64px]' />
              <LangText lngKey='f6aecc19' className='text-[30px] mt-[41px] font-bold'>{t('f6aecc19')}</LangText>
              <LangText lngKey='c615127c' className='text-[18px] mt-[29px] text-[#666666] leading-[1.5]'>{t('c615127c')}</LangText>
              <div className='flex flex-col gap-5 mt-[38px]'>
                <div className='flex items-center gap-4'>
                  <span className='w-3 h-3 bg-[#3096FF] rounded-[50%] block'></span>
                  <LangText lngKey='020337fc' className='text-[18px]'>{t('020337fc')}</LangText>
                </div>
                <div className='flex items-center gap-4'>
                  <span className='w-3 h-3 bg-[#3096FF] rounded-[50%] block'></span>
                  <LangText lngKey='78eb56c3' className='text-[18px]'>{t('78eb56c3')}</LangText>
                </div>
                <div className='flex items-center gap-4'>
                  <span className='w-3 h-3 bg-[#3096FF] rounded-[50%] block'></span>
                  <LangText lngKey='78eb56c3' className='text-[18px]'>{t('78eb56c3')}</LangText>
                </div>
              </div>
            </div>
            <div className='flex-1 bg-white min-h-[406px] rounded-[30px] p-10 flex flex-col'>
              <img src={preFixImgUrl('8f607929903e454155e987ecae5b35ea.png')} className='w-[64px] h-[64px]' />
              <LangText lngKey='76842857' className='text-[30px] mt-[41px] font-bold'>{t('76842857')}</LangText>
              <LangText lngKey='253187c2' className='text-[18px] mt-[29px] text-[#666666] leading-[1.5]'>{t('253187c2')}</LangText>
              <div className='flex flex-col gap-5 mt-[38px]'>
                <div className='flex items-center gap-4'>
                  <span className='w-3 h-3 bg-[#3096FF] rounded-[50%] block'></span>
                  <LangText lngKey='74019af6' className='text-[18px]'>{t('74019af6')}</LangText>
                </div>
                <div className='flex items-center gap-4'>
                  <span className='w-3 h-3 bg-[#3096FF] rounded-[50%] block'></span>
                  <LangText lngKey='c8a5e252' className='text-[18px]'>{t('c8a5e252')}</LangText>
                </div>
                <div className='flex items-center gap-4'>
                  <span className='w-3 h-3 bg-[#3096FF] rounded-[50%] block'></span>
                  <LangText lngKey='1dd47ddc' className='text-[18px]'>{t('1dd47ddc')}</LangText>
                </div>
              </div>
            </div>
          </div>
          <div className='w-full rounded-[30px] bg-cover h-[449px] mt-[48px] relative' style={{ backgroundImage: `url(${preFixImgUrl('46c6cc4fc29082a1ea17345e1c7ae633.png')})` }}>
            <div className='flex flex-col pl-[90px]'>
              <LangText lngKey='57fda304' className='text-[30px] text-white mt-[113px]'>{t('57fda304')}</LangText>
              <div className='flex flex-col gap-7 mt-9'>
                {
                  services.map((item, index) => (
                    <div
                      key={item.titleKey}
                      className='flex items-center cursor-pointer'
                      onClick={() => {
                        setActiveSwiper(index)
                        swiperRef.current?.slideToLoop(index)
                      }}>
                      <span className={classNames('w-3 h-3 rounded-[50%] mr-4', activeSwiper === index ? 'bg-[#30E9FF]' : 'bg-white')}></span>
                      <LangText lngKey={item.titleKey} className='text-[18px] text-white'>{t(item.titleKey)}</LangText>
                    </div>
                  ))
                }
              </div>
            </div>
            <div className='w-[337px] absolute right-[148px] bottom-0'>
              <Swiper
                slidesPerView='auto'
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                loop
                modules={[Autoplay]}
                onSwiper={(swiper) => {
                  swiperRef.current = swiper
                }}

                onRealIndexChange={(swiper: SwiperType) => {
                  const realIndex = swiper.realIndex
                  setActiveSwiper(realIndex)
                }}

              >
                {
                  services.map((item, index) => (
                    <SwiperSlide key={index}>
                      <img src={item.img} className='w-[337px] h-[418px]' />
                    </SwiperSlide>
                  ))
                }
              </Swiper>
            </div>
          </div>
        </div>
      </div>
      {/* 服务保障 */}
      <div className='bg-white pb-[138px] py-[169px]'>
        <div className='max-w-8xl mx-auto px-10 text-center flex flex-col items-center'>
          <LangText className='text-[36px] font-bold' lngKey='0117a822'>{t('0117a822')}</LangText>
          <div className='flex justify-between mt-[93px] gap-[21px]'>
            <div className='w-[285px] h-[225px] bg-linear-to-t from-[#399BFF] to-[#4DC6FF] rounded-[20px] flex flex-col justify-center items-center'>
              <div className='w-[89px] h-[89px] rounded-[50%] bg-white flex justify-center items-center'>
                <img src={preFixImgUrl('7e51c447eb1ca43b7b317c635a705a05.png')} className='h-[44px]' />
              </div>
              <LangText lngKey='ec484367' className='text-[30px] text-white mt-[35px]'>{t('ec484367')}</LangText>
            </div>
            <div className='w-[285px] h-[225px] bg-linear-to-t from-[#399BFF] to-[#4DC6FF] rounded-[20px] flex flex-col justify-center items-center'>
              <div className='w-[89px] h-[89px] rounded-[50%] bg-white flex justify-center items-center'>
                <img src={preFixImgUrl('94ef7b0d3dae2cbed09dffdb40712db5.png')} className='h-[44px]' />
              </div>
              <LangText lngKey='e47e40ad' className='text-[30px] text-white mt-[35px]'>{t('e47e40ad')}</LangText>
            </div>
            <div className='w-[285px] h-[225px] bg-linear-to-t from-[#399BFF] to-[#4DC6FF] rounded-[20px] flex flex-col justify-center items-center'>
              <div className='w-[89px] h-[89px] rounded-[50%] bg-white flex justify-center items-center'>
                <img src={preFixImgUrl('e78d485224ca3f0c8eb9decfd0b298b9.png')} className='h-[44px]' />
              </div>
              <LangText lngKey='4deb4752' className='text-[30px] text-white mt-[35px]'>{t('4deb4752')}</LangText>
            </div>
            <div className='w-[285px] h-[225px] bg-linear-to-t from-[#399BFF] to-[#4DC6FF] rounded-[20px] flex flex-col justify-center items-center'>
              <div className='w-[89px] h-[89px] rounded-[50%] bg-white flex justify-center items-center'>
                <img src={preFixImgUrl('8ebcd501ea76cd1d5c0acc2858aab72b.png')} className='h-[44px]' />
              </div>
              <LangText lngKey='cda12699' className='text-[30px] text-white mt-[35px]'>{t('cda12699')}</LangText>
            </div>

          </div>
        </div>

      </div>
      {/* 让旅行更轻松 */}
      <div className='w-full h-[435px] bg-cover bg-center bg-no-repeat flex flex-col items-center' style={{ backgroundImage: `url(${preFixImgUrl('fd04bc51e566e82a612fdb399a5b0d9e.png')})` }}>
        <LangText className='text-white text-[44px] mt-[113px]' lngKey='26db8846'>{t('26db8846')}</LangText>
        <LangText className='text-white text-[30px] mt-[30px] font-normal' lngKey='63829f9b'>{t('63829f9b')}</LangText>
        <div className='flex gap-[25px] mt-[60px]'>
          <OutLink platform={PlatformEnum.SGW}>
            <div className='h-[62px] min-w-[231px] text-white px-[44px] flex items-center justify-center rounded-[31px]  w-fit text-[24px] bg-linear-to-r from-[#3984FF] to-[#0DACFF]  cursor-pointer'>
              <LangText lngKey='bcc799b1'>{t('bcc799b1')}</LangText>
            </div>
          </OutLink>
          <div className='h-[62px] min-w-[231px] text-white px-[44px] flex items-center justify-center rounded-[31px] outline outline-white w-fit text-[24px] cursor-pointer'
            onClick={() => navigate('/service-center')}
          >
            <LangText lngKey='ad839901'>{t('ad839901')}</LangText>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SagawaExp;